/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Import packages that are required globally
------------------------------------------------------------------*/

import * as Meteora from 'meteora';
import Classy from '@meteora-digital/classy';
import TweenController from '@meteora-digital/tween';
import MagicScrollsController from 'magic-scrolls';
import MacyController from 'macy';
import { tns } from 'tiny-slider/src/tiny-slider';

/*------------------------------------------------------------------
Assign the packages to the window object
------------------------------------------------------------------*/

window.Classy = Classy;
window.Meteora = Meteora;
window.TweenController = TweenController;
window.MagicScrollsController = MagicScrollsController;
window.MacyController = MacyController;
window.tns = tns;

/*------------------------------------------------------------------
Add scripts to the ScriptLoader object below
------------------------------------------------------------------*/

/*------------------------------------------------------------------
@emmanuel, I added this script here because it was not initiating 
on viewports lower than or equal to 967px, I also commented out
the corresponding on below in the ScriptLoader object
------------------------------------------------------------------*/
import './components/region-select';
document.addEventListener('DOMContentLoaded', function () {
  // Add the src and a condition required to load the script
  window.ScriptLoader = ScriptLoader({
    './components/global': true,
    './elements/header': document.querySelector('.js-header'),
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    './elements/selects': document.querySelector('select'),
    './elements/blob': document.querySelector('.js-blob'),
    './elements/videos': document.querySelector('[data-video]'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    // './components/region-select': document.querySelector('.js-region-select'),
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/parallax': document.querySelector('[data-parallax]'),
    './components/equalizer': document.querySelector('[data-equalize-watch]'),
    './blocks/blob/image-text': document.querySelector('.js-blob__image-text--blob'),
    './blocks/default/tabbed-content': document.querySelector('.js-tabbed-content'),
    './blocks/default/accordion': document.querySelector('.js-accordion'),
    './blocks/default/slider': document.querySelector('.js-slider'),
    './blocks/default/solutions': document.querySelector('.js-solutions'),
    './blocks/default/call-to-action': document.querySelector('.js-call-to-action'),
    './blocks/default/link': document.querySelector('.js-default-link'),
    './blocks/default/showcase': document.querySelector('.js-showcase'),
    './blocks/animated/solutions': document.querySelector('.js-animated-solutions'),
    './pages/blog': document.querySelector('.js-blog'),
    './pages/team': document.querySelector('.js-team'),
    './pages/contact': document.querySelector('.js-contact-page')
  });
});

/*------------------------------------------------------------------
Script Loader
------------------------------------------------------------------*/

function ScriptLoader() {
  var imports = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // An array of the import object keys
  var scripts = Object.keys(imports);
  // For debugging purposes only
  var components = [];
  // The index we are up to with loading scripts
  var index = -1;
  var load = function load() {
    // Make sure we have a script to import
    if (index >= scripts.length) {
      // Once everything has loaded, fire a 'scripts-loaded' event 
      setTimeout(function () {
        return window.dispatchEvent(new Event('scripts-loaded'));
      }, 500);
      return;
    }
    ;

    // Increment the index
    index += 1;

    // If this script is not needed, continue to the next script;
    if (!imports[scripts[index]]) {
      load();
      return;
    }
    ;

    // Otherwise continue on to load the script
    import("".concat(scripts[index])).then(function () {
      return components.push(scripts[index]);
    }).catch(function (error) {
      return console.warn(error);
    }).finally(function () {
      return load();
    });
  };
  load();
  return components;
}
window.addEventListener('scripts-loaded', function () {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
  window.ScrollLocker.unlock();
});